"use strict";
var header = function () {
    var header = document.querySelector('.l-header');
    if (!header) {
        return;
    }
    var html = document.documentElement;
    var triggerButton = header.querySelector('.c-btnHamburger');
    setTimeout(function () {
        header.classList.remove('-hidden');
        header.removeAttribute('style');
    }, 250);
    var lastScroll = 0;
    var maxScroll = 0;
    window.addEventListener('scroll', function () {
        var scroll = window.pageYOffset || document.documentElement.scrollTop;
        scroll > maxScroll ? (maxScroll = scroll) : null;
        if (scroll > lastScroll && scroll > 100) {
            // header.classList.remove('-sticked')
            header.classList.add('-hidden');
        }
        else {
            if (maxScroll - scroll > 250 || scroll == 0) {
                header.classList.remove('-hidden');
                maxScroll = scroll;
            }
            scroll > 100 ? header.classList.add('-sticked') : header.classList.remove('-sticked');
        }
        lastScroll = scroll <= 0 ? 0 : scroll;
    });
    triggerButton === null || triggerButton === void 0 ? void 0 : triggerButton.addEventListener('click', function () { return html.classList.toggle('-mobileNavOpen'); });
    window.addEventListener('resize', function () { return html.classList.remove('-mobileNavOpen'); });
    var eventResize = document.createEvent('Event');
    eventResize.initEvent('resize', false, true);
    window.dispatchEvent(eventResize);
    var eventScroll = document.createEvent('Event');
    eventScroll.initEvent('scroll', false, true);
    window.dispatchEvent(eventScroll);
};
header();
